const { inRange } = require('lodash');
const { TEXT_HORIZONTAL_GROW } = require('../calculateGrowDimensions/constants');
const getRootPosition = require('../getRootPosition');
const { LAYER_TYPES } = require('../layerTypes');
const { SNAPPING_BUFFER } = require('./constants');

/**
 * Returns a center anchor for a given element position
 */
const getCenterAnchor = ({ left, width }) => left + (width / 2);

/**
 * Returns a left anchor for a given element position
 */
const getLeftAnchor = ({ left }) => left;

/**
 * Returns a right anchor for a given element position
 */
const getRightAnchor = ({ left, width }) => (left + width);

/**
 * Checks if an array of given roots is snapped, according to the given getAnchor result
 * @param {Root[]} roots - The array of roots
 * @param {Function} getAnchor - The get anchor function to run on every single root
 * @returns {Boolean}
 */
const isSnapped = (roots, getAnchor) => {
    const rootDimensions = roots.map(getAnchor);
    const snappingRange = [rootDimensions[0] - SNAPPING_BUFFER, rootDimensions[0] + SNAPPING_BUFFER];

    return rootDimensions.every((dimension) =>
        inRange(dimension, ...snappingRange)
    );
};

/**
 * Returns a given roots their text growth enforcement
 * The enforcement is determined by the following:
 * 1) If all elements are snapped to the center, Center growth will be enforced
 * 2) If Icon is most left, And text roots are snapped, Right growth will be enforced
 * 2) If Icon is most right, And text roots are snapped, Left growth will be enforced
 * @param {Root[]}roots
 * @returns {TEXT_HORIZONTAL_GROW.CENTER|TEXT_HORIZONTAL_GROW.LEFT|TEXT_HORIZONTAL_GROW.RIGHT|Boolean}
 */
const getRootsTextEnforcement = (roots) => {
    const rootsPositions = roots.filter((root) => root.layerType !== LAYER_TYPES.SHAPE)
        .map((root) => ({ layerType: root.layerType, ...getRootPosition(root) }));
    const textRootsPositions = rootsPositions.filter((root) => root.layerType === LAYER_TYPES.TEXT);

    const isVertical = isSnapped(rootsPositions, getCenterAnchor);

    if (isVertical) {
        return TEXT_HORIZONTAL_GROW.CENTER;
    }

    const { left: iconRootLeft } = rootsPositions.find(
        (root) => root.layerType === LAYER_TYPES.ICON
    );

    const isIconMostLeft = textRootsPositions.every(
        (rootPosition) => iconRootLeft <= rootPosition.left
    );

    if (isIconMostLeft) {
        const snappedLeft = isSnapped(textRootsPositions, getLeftAnchor);

        // TODO - Data horizontal grow issue - should be data horizontal anchor.
        return snappedLeft && TEXT_HORIZONTAL_GROW.LEFT;
    }

    const isIconMostRight = !isIconMostLeft && textRootsPositions.every(
        ({ left, width }) => iconRootLeft >= left + width
    );

    if (isIconMostRight) {
        const snappedRight = isSnapped(textRootsPositions, getRightAnchor);

        // TODO - Data horizontal grow issue - should be data horizontal anchor.
        return snappedRight && TEXT_HORIZONTAL_GROW.RIGHT;
    }

    return false;
};

module.exports = getRootsTextEnforcement;
